import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    props: {
        paymentdata:Object,
    },
    watch: { 
        paymentdata: function(newVal, oldVal) { // watch this prop
            //this.set_chat_view = false; //reload
            //this.chat_log = []; //reload
            this.setPaymentDetails();
           // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        }
    },
    data () {
        return {
            user:{},
            payment_mode:1, //default automatic payment
            payment_message:"",
            loading:false,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                this.setComponent('reset-edit','');
            }else{
                this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },

        setPaymentDetails(){

        },
       
        processPaymentSingle(payment_mode){ 
            let data = this.paymentdata;
            this.activate_processing();
            let paydata = {};
            //base data
            paydata.payment_data = data;
            //payer details
            paydata.payer = {
                payerName:data.payer_name,
                payerEmail:data.payer_email,
                payerPhone:data.payer_phone,
            };
            //other details
            paydata.payment_total_amount = data.pay_total_amount;
            paydata.payment_currency = data.pay_currency;
            paydata.payment_ref = data.pay_payment_ref;
            paydata.payment_details = data.pay_payment_details;
            paydata.processing_fee_status = data.pay_processing_fee_status;
            paydata.payment_processing_fee_transaction_type = data.pay_processing_fee_transaction_type;
            paydata.processing_fee = data.pay_processing_fee;
            paydata.payment_transaction_type = data.pay_transaction_type;
            paydata.payment_transaction_module_id = data.pay_transaction_module_id;
            paydata.payment_data_index = data.pay_data_index;
            paydata.payment_data_route = data.pay_data_route;
            
            //set sub accounts
            paydata.payment_subaccounts = [];
            if((Object.keys(data.payment_sub_accounts).length !== 0)){
                data.payment_sub_accounts.forEach(function(sub) {
                    var sub_account_1 = {
                        id: sub.bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                        transaction_charge: sub.sub_account_amount_to_pay,
                        transaction_charge_type: "flat_subaccount"
                    };
                    paydata.subaccounts.push(sub_account_1);
                });
            }

            //set payment meta
            paydata.payment_meta = [];
            if((Object.keys(data.payment_meta).length !== 0)){
                data.paymeta.forEach(function(meta) {
                    var meta_value = {
                        metaname: meta.metaname,
                        metavalue: meta.meta,
                    }
                    paydata.payment_meta.push(meta_value);
                });
            }
            
            
            if(payment_mode == 1){
                paydata.payment_mode = 1;//gateway
                this.processPaymentRavepay(paydata);
            }

            if(payment_mode == 2){
                paydata.payment_mode = 2;//collections
                this.updatePaymentSingle(paydata); 
            }

            if(payment_mode == 3){
                paydata.payment_mode = 3;//manualTransfer
                this.updatePaymentSingle(paydata);
            }
           
       
        },

        processPaymentRavepay(paydata) {
            let self = this;
            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test, //test //devlot
                // PBFPubKey: service.ravepay_public_live_paga, //api public key
                customer_email: paydata.payer.payerEmail, // "mail@gmail.com"
                amount: paydata.payment_total_amount,//(Math.round(order.total_amount))//self.total_fee,
                customer_phone: paydata.payer.payerPhone, //"234099940409"
                currency: paydata.payment_currency,
                payment_method: "both",
                txref:paydata.payment_ref,
                subaccounts: paydata.payment_subaccounts,
                meta: paydata.payment_meta,
                onclose: function() {
                   //refresh
                },
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        self.updatePaymentSingle(txref,paydata,"autoUpdate"); 
                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": service.ravepay_secret_live_paga, //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                            
                        // }).catch((err) => {
                            
                        // })
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
                }
            });
        },
        //../process payments

        // update payments
        updatePaymentSingle(paydata) {
            //some settings
           
            var payload = {
                payment_service_type:"single",
                payment_service_ref: paydata.payment_ref,
                payment_service_amount_paid: paydata.total_amount,
                payment_service_user_id: this.user.user_id,
                payment_service_payment_data: paydata.payment_data,
                payment_service_payment_details: paydata.payment_details,
                //processing fee details
                payment_service_processing_fee_status: paydata.processing_fee_status,
                payment_service_processing_fee_transaction_type: paydata.payment_processing_fee_transaction_type,
                payment_service_processing_fee_transaction_amount:paydata.payment_processing_fee,
                //manual payment updates and confirmation
                payment_service_mode:paydata.payment_mode,
                payment_service_transaction_type:paydata.payment_transaction_type,
                payment_service_transaction_module_id:paydata.payment_transaction_module_id,
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
                service.updatePaymentService(this, payload).then(data => {
                    if(data.body.status == 200) {
                        //return order id if one and navigate with it to orders
                        // toastr.success("Payment Processed!", "Success!");
                        this.data_processing_message = "Payment Processed!";
                        this.checkout_orders[index] = data.body.data;
                        this.processed_single_order_count++;
                        // location.replace("/orders/");
                        this.deactivate_processing();
                    }else {
                        //console.log("error")
                        // toastr.error('Sorry, could not update payment', 'Warning!');
                        this.data_processing_message = "Sorry, could not update payment";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                        // toastr.error('Sorry, could not process information', 'Warning!');
                        this.data_processing_message = "Sorry, could not process information";
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Something went wrong', 'Warning!');
                this.data_processing_message = "Something went wrong";
                this.deactivate_processing();
            }
            
        },

        
    },
    created: function(){
        console.log("kkktytt")
        console.log(this.paymentdata)
        // this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/PaymentService/script.js